import React from "react";

// Public support page (reachable without an account). App Store Connect
// requires a support URL that gives users an easy way to contact us (App
// Review Guideline 1.5); the prelaunch site served this content at /support
// and this page keeps the same path live after the domain switch. Keep the
// support email in sync with the App Store listing.
export default function Support() {
  return (
    <main className="legalPage">
      <div className="legalPage__inner">
        <h1 className="legalPage__title">BetterIntentions Support</h1>
        <p className="legalPage__lead">
          Need help with BetterIntentions? This page explains how to reach us
          and where to find answers to common questions. BetterIntentions is
          operated by BetterIntentions, LLC.
        </p>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">Contact us</h2>
          <div className="legalPage__sectionContent">
            <p>
              For help with your account, the app, or anything else, email{" "}
              <a href="mailto:support@betterintentions.com">
                support@betterintentions.com
              </a>
              . Include the email address on your account so we can help you
              faster. We typically respond within 2 business days.
            </p>
          </div>
        </section>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">Common questions</h2>
          <div className="legalPage__sectionContent">
            <ul>
              <li>
                <strong>Delete your account</strong> — see{" "}
                <a href="/delete-account">Delete Your Account</a> for in-app
                and email deletion options.
              </li>
              <li>
                <strong>Privacy questions or data requests</strong> — see our{" "}
                <a href="/privacy-policy">Privacy Policy</a> or email{" "}
                <a href="mailto:privacy@betterintentions.com">
                  privacy@betterintentions.com
                </a>
                .
              </li>
              <li>
                <strong>Child safety concerns</strong> — see our{" "}
                <a href="/child-safety.html">Child Safety Standards</a> for how to
                report concerns and how we enforce them.
              </li>
              <li>
                <strong>Unsubscribe from emails</strong> — every marketing
                email we send includes an unsubscribe link at the bottom.
              </li>
            </ul>
          </div>
        </section>
      </div>
    </main>
  );
}
